module.exports = "<div class=\"loading\" [style.margin-left.%]='left' [style.margin-top.%]='top' [style.width.px]='widthHeight' [style.height.px]='widthHeight'>\r\n  <div></div>\r\n  <div></div>\r\n  <div></div>\r\n</div>\r\n\r\n<!--  -->\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/ui/loader/loader.component.html
// module id = ./src/app/ui/loader/loader.component.html
// module chunks = main